import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import amber from '@material-ui/core/colors/amber';
import primaryColor from '../colors/app-primary';

const theme = createMuiTheme({
	palette: {
		type: 'dark',
		primary: primaryColor,
		secondary: red,
		error: amber,
	},

	typography: {
		useNextVariants: true,
	},

	overrides: {
		MuiListItem: {
			gutters: {
				'@media (min-width:600px)': {
					paddingLeft: 16,
					paddingRight: 16,
				},
				paddingLeft: 16,
				paddingRight: 16,
			},
		},
	},
});


export default theme;